import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { restaurantAPI } from '../services/api';

// Flutter App Theme Colors (exact match)
const theme = {
  primaryColor: '#FF6961',
  primaryDark: '#E6524A',
  backgroundColor: '#F8FAFC',
  textPrimary: '#0F172A',
  textSecondary: '#64748B',
  warningColor: '#F59E0B',
};

function RestaurantHeader() {
  const navigate = useNavigate();
  const [restaurant, setRestaurant] = useState(null);

  useEffect(() => {
    fetchRestaurant();
  }, []);

  const fetchRestaurant = async () => {
    try {
      const response = await restaurantAPI.getMyRestaurant();
      setRestaurant(response.data.data.restaurant);
    } catch (error) {
      console.error('Failed to fetch restaurant:', error);
    }
  };

  return (
    <header style={{
      background: 'white',
      padding: '12px 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: '1px solid #E5E7EB',
      position: 'sticky',
      top: 0,
      zIndex: 100,
      width: '100%',
      boxSizing: 'border-box',
    }}>
      {/* Foodwinc Logo */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <div style={{
          width: '42px',
          height: '42px',
          borderRadius: '10px',
          background: `linear-gradient(135deg, ${theme.primaryColor} 0%, ${theme.primaryDark} 100%)`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 8px rgba(255, 105, 97, 0.3)',
        }}>
          <span style={{ fontSize: '24px' }}>🍽️</span>
        </div>
        <div>
          <h1 style={{
            fontSize: '24px',
            fontWeight: '800',
            color: theme.primaryColor,
            margin: 0,
            letterSpacing: '-0.5px',
          }}>
            Foodwinc
          </h1>
          <p style={{
            fontSize: '12px',
            color: theme.textSecondary,
            margin: 0,
            fontWeight: '500',
          }}>
            Restaurant Partner
          </p>
        </div>
      </div>

      {/* Right side - Restaurant info & notification */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        {restaurant && (
          <div style={{ textAlign: 'right' }}>
            <p style={{
              fontSize: '14px',
              fontWeight: '600',
              color: theme.textPrimary,
              margin: 0,
            }}>
              {restaurant.name}
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'flex-end' }}>
              <span style={{ color: theme.warningColor, fontSize: '14px' }}>★</span>
              <span style={{ fontSize: '12px', color: theme.textSecondary }}>
                {restaurant.rating?.toFixed(1) || '0.0'} ({restaurant.totalReviews || 0} reviews)
              </span>
            </div>
          </div>
        )}
        <button
          onClick={() => navigate('/restaurant/notification-settings')}
          style={{
            width: '42px',
            height: '42px',
            borderRadius: '50%',
            border: 'none',
            background: theme.backgroundColor,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background 0.2s',
          }}
          title="Notification Settings"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={theme.textPrimary} strokeWidth="2">
            <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0" />
          </svg>
        </button>
      </div>
    </header>
  );
}

export default RestaurantHeader;
